export const FEATURES_IDS = {
    ADD_LINE: 3,
    // MANUAL_ORDERS: 2,
    // PASSENGERS_MANAGER: 3,
    // COURSES_BUILDING: 7,
    // REPORTS: 4,
};
